/* eslint-disable no-param-reassign */
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

export const api: AxiosInstance = axios.create({
  baseURL: "https://api.luvi.app",
  // baseURL: "http://localhost:3333",
  timeout: 60000, // 60 segundos de timeout para uploads grandes
});

api.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = localStorage.getItem("@LuviApp:token");
    if (token) {
      config = {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        },
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// Interceptor de resposta para tratar erros de autenticação
api.interceptors.response.use(
  response => response,
  error => {
    // Se o token expirou ou é inválido
    if (error.response?.status === 401) {
      // Limpar dados de autenticação
      localStorage.removeItem("@LuviApp:token");
      localStorage.removeItem("@LuviApp:user");

      // Redirecionar para login com reload completo para limpar o estado do React
      window.location.href = "/signin";
    }
    return Promise.reject(error);
  },
);
